import React from 'react'

import { useEffect, useContext } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import Loader from '../Loader'
import { stripePk } from '../../env'
import stripeHelpers from '../../helpers/stripe'
import StripeSecretContext from '../../context/StripeSecret'
import PlansContext from '../../context/Plans'
import SelectedPlanContext from '../../context/SelectedPlan'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import Toast from '../../components/Toast'

import PlanPicker from '../PlanPicker'
import PaymentSection from '../PaymentSection'

import './Checkout.scss'

/**
 * Main content wrapper component
 *
 * @component
 * @example
 * return (
 *   <Main />
 * )
*/

const stripePromise = loadStripe(stripePk)

const Main = () => {

    const { stripeSecret, setStripeSecret } = useContext(StripeSecretContext)
    const { plans } = useContext(PlansContext)
    const { setSelectedPlan } = useContext(SelectedPlanContext)

    const setupStripe = () => {
        // grab info from url params
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        const planName = urlParams.get('plan')

        if (planName) {
            setSelectedPlan(plans.filter(plan => plan.name === planName)[0])
            fetchInitialClientSecret(plans.filter(plan => plan.name === planName)[0].name)
        }
        else {
            setSelectedPlan(plans.filter(plan => plan.name === 'Pro')[0])
            fetchInitialClientSecret(plans.filter(plan => plan.name === 'Pro')[0].name)
        }

    }

    const fetchInitialClientSecret = async planName => {
        const res = await stripeHelpers.fetchClientSecret('', planName)
        setStripeSecret(res.clientSecret)
    }

    const handleCheckoutLoad = async () => await setupStripe()

    useEffect(() => handleCheckoutLoad(), [])

    const stripeOptions = { clientSecret: stripeSecret }

    if (!stripeSecret) return <Loader />
    return (
        <>
            <Navbar />
        
            <Elements stripe={stripePromise} options={stripeOptions}>

            <main className="container py-5">

                <div id="checkout" className="row py-5 w-100 align-items-start">
                    <PlanPicker />
                    <PaymentSection />
                </div>

            </main>

            </Elements>

            <Footer />

            <Toast />
        </>
    )

}

export default Main